import { useEffect, useState, type FormEvent } from 'react';
import { useAuth } from '../state/auth';
import { Champ } from '../components/ui';
import { API_BASE, definirApi, urlApi } from '../api/config';
import { SelecteurLangue } from '../components/SelecteurLangue';
import { T } from '../i18n';
import { useMarque } from '../state/marque';

export default function Connexion() {
  const { connexion } = useAuth();
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const marque = useMarque();
  // L'identite de l'agence : la meme que sur la facture, jamais reecrite ici.
  const [identite, setIdentite] = useState<{ raisonSociale?: string; rc?: string; adresse?: string } | null>(null);
  useEffect(() => {
    fetch(urlApi('/api/auth/identite')).then((r) => (r.ok ? r.json() : null)).then(setIdentite).catch(() => {});
  }, []);

  async function soumettre(e: FormEvent) {
    e.preventDefault();
    setErreur(''); setEnvoi(true);
    try { await connexion(email, motDePasse); }
    catch (err) { setErreur(err instanceof Error ? err.message : T.connexion.impossible); }
    finally { setEnvoi(false); }
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)', minHeight: '100vh' }}>
      <div style={{ background: 'linear-gradient(160deg,#0F1B2D,#16233A)', color: '#fff', padding: '56px 48px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div>
          <div style={{ fontSize: 30, fontWeight: 800, letterSpacing: 3 }}>{marque?.principal ?? '\u00A0'}<span style={{ color: 'var(--accent)' }}>.</span></div>
          <div style={{ fontSize: 12, letterSpacing: 5, opacity: .65, marginTop: 2 }}>{marque?.secondaire ?? ''}</div>
          <p style={{ marginTop: 8, opacity: .8, fontSize: 15 }}>{T.connexion.sousTitre}</p>
        </div>
        <p style={{ fontSize: 22, lineHeight: '32px', fontWeight: 600, maxWidth: 420 }}>
          {T.connexion.accroche}<br />
          <span style={{ color: 'var(--accent)' }}>{T.connexion.accrocheSuite}</span>
        </p>
        <div style={{ fontSize: 12, opacity: .55 }}>
          {identite ? [identite.raisonSociale, identite.rc && `RC ${identite.rc}`, identite.adresse]
            .filter(Boolean).join(' · ') : '\u00A0'}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 32, background: '#fff' }}>
        <form onSubmit={soumettre} style={{ width: 'min(380px,100%)', display: 'grid', gap: 16 }}>
          <div>
            <h1 style={{ fontSize: 26 }}>{T.connexion.titre}</h1>
            <p className="sourdine mini" style={{ marginTop: 4 }}>{T.connexion.identifiezVous}</p>
          </div>
          {erreur && <div className="bandeau ko"><div>{erreur}</div></div>}
          <Champ label={T.connexion.email}>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required autoFocus />
          </Champ>
          <Champ label={T.connexion.motDePasse}>
            <input type="password" value={motDePasse} onChange={(e) => setMotDePasse(e.target.value)} autoComplete="current-password" required />
          </Champ>
          <button className="btn btn-p btn-l btn-bloc" disabled={envoi}>{envoi ? T.connexion.envoi : T.connexion.seConnecter}</button>
          {/* Jamais en production : cette page est publique, et afficher trois
              adresses réelles avec leur mot de passe partagé revient à donner
              les clés de la caisse. */}
          {import.meta.env.DEV && (
            <p className="mini sourdine" style={{ textAlign: 'center', marginTop: 4 }}>
              {T.connexion.demonstration}
            </p>
          )}

          {/* Sans nom de domaine, l'adresse du serveur change a chaque redemarrage
              du tunnel. On la rend modifiable ici plutot que de reconstruire le site. */}
          <details style={{ marginTop: 6 }}>
            <summary className="mini sourdine" style={{ cursor: 'pointer', textAlign: 'center' }}>
              {T.connexion.serveur(API_BASE || T.connexion.memeOrigine)}
            </summary>
            <div style={{ marginTop: 8 }}>
              <Champ label={T.connexion.adresseServeur} aide={T.connexion.adresseServeurAide}>
                <input defaultValue={API_BASE} placeholder="https://xxx.trycloudflare.com"
                       onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); definirApi((e.target as HTMLInputElement).value); } }} />
              </Champ>
            </div>
          </details>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <SelecteurLangue compact />
          </div>
        </form>
      </div>
    </div>
  );
}
